import { Card, Grid, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import CloseIcon from '@material-ui/icons/Close';
import { debounce } from 'lodash';
import React from 'react';

import Search from '../static/_assets/search.svg';

interface ISearchBarProps extends WithStyles<typeof styles> {
  className?: any;
  cascadeQuickFilterText?: any;
  supressRecentSearch?: boolean;
  handleSearchOnEnter?: any;
  elevation?: number;
  handleElasticInput?: any;
  isQuickSearch?: boolean;
  type?: any;
  defaultAdornmentValue?: string;
  updateCandidatesOnAdornmentChange?: boolean;
  handleExternalDelete?: any;
  delaySearch?: boolean;
  clearSearch?: boolean;
  useRevampedFilters?: boolean;
}

interface ISearchBarState {
  searchValue: string;
  recentSearchList: Array<string>;
  adornmentValue?: string;
}

class SearchBar extends React.Component<ISearchBarProps, ISearchBarState> {
  constructor(props: ISearchBarProps) {
    super(props);
    this.state = {
      searchValue: '',
      recentSearchList: [],
      adornmentValue: props.defaultAdornmentValue ? props.defaultAdornmentValue : 'Current View',
    };
  }

  handleDelete = (event: any) => {
    event.preventDefault();
    this.props.handleSearchOnEnter?.('');
    this.props.handleElasticInput?.call(null, '');
    this.props.handleExternalDelete && this.props.handleExternalDelete();
    this.setState({ searchValue: '' });
  };

  handleInputTime = debounce((filterText: string) => {
    if (filterText.length >= 2 || filterText === '') {
      this.props.handleElasticInput?.call(null, filterText);
      this.props.cascadeQuickFilterText?.call(null, filterText);
    }
  }, 1000);

  handleChange = (event: any) => {
    const filterText: string = event.target.value;
    this.setState({ searchValue: filterText });
    if (this.props.handleElasticInput || this.props.delaySearch) {
      this.handleInputTime(filterText);
    } else {
      this.props.cascadeQuickFilterText?.call(null, filterText);
    }
  };

  handleEnter = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      this.props.handleSearchOnEnter && this.props.handleSearchOnEnter(this.state.searchValue);
      this.props.cascadeQuickFilterText?.call(null, this.state.searchValue);
    }
  };

  handleIconClick = (event: any) => {
    if (this.props.handleSearchOnEnter) {
      event.preventDefault();
      this.props.handleSearchOnEnter && this.props.handleSearchOnEnter(this.state.searchValue);
      this.props.cascadeQuickFilterText?.call(null, this.state.searchValue);
    } else {
      this.handleSearch(event, this.state.searchValue);
    }
  };
  // function for filter input change.
  handleSearch = (event: any, searchText: string) => {
    event.stopPropagation();
    this.props.cascadeQuickFilterText?.call(null, searchText);
  };

  componentDidUpdate(prevProps: ISearchBarProps) {
    if (this.props.useRevampedFilters && prevProps.clearSearch !== this.props.clearSearch) {
      this.setState({ searchValue: '' });
    }
  }

  public render() {
    const { classes } = this.props;

    return (
      <Grid container className={classes.searchGrid}>
        <Grid item xs>
          <Card
            className={[classes.root, this.props.className].join(' ')}
            elevation={0}
            onClick={(event) => this.handleSearch(event, this.state.searchValue)}
            data-testid={this.props.type ? this.props.type + '_searchbar' : null}
          >
            <Tooltip
              title={this.props.isQuickSearch ? 'Start Typing to Search' : 'Press Enter to Search'}
              placement="bottom"
            >
              <InputBase
                className={classes.input}
                placeholder="Search"
                onChange={(event) => this.handleChange(event)}
                onKeyUp={(event) => this.handleEnter(event)}
                value={this.state.searchValue}
              />
            </Tooltip>
            {this.state.searchValue !== '' && (
              <CloseIcon
                onClick={(event) => {
                  this.handleDelete(event);
                }}
                className={classes.closeButton}
              ></CloseIcon>
            )}
            <IconButton
              className={classes.iconButton}
              aria-label="Search"
              onClick={(event) => {
                this.handleIconClick(event);
              }}
            >
              <img src={Search} className={classes.searchIcon} />
            </IconButton>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

const styles = (styles: any) =>
  createStyles({
    root: {
      // padding: "2px 2px",
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      maxWidth: '400px',
      borderRadius: '8px',
      background: '#f2f2f2',
      overflow: 'visible',
      [styles.breakpoints.down(1600)]: {
        width: '100%',
        maxWidth: '280px',
      },
      '&:hover': {
        backgroundColor: lighten(styles.palette.primary.main, 0.8),
      },
    },
    middle: {
      height: 5,
    },
    menuItem: {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
    input: {
      marginLeft: 20,
      flex: 1,
      color: '#333',
      fontSize: 16,
      paddingTop: '3px',
    },
    searchGrid: {
      height: 40,
    },

    deleteIcon: {
      color: '#808080',
    },

    iconButton: {
      fontSize: 14,
      color: '#808080',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    closeButton: {
      fontSize: 24,
      color: '#808080',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    hide: {
      display: 'none',
    },
    chips: {
      height: 60,
      overflow: 'auto',
    },
    recentSearchContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'left',
    },
    searchIcon: {
      width: 20,
      height: 20,
    },
    selectfont: {
      paddingLeft: '20px',
      color: '#808080',
      backgroundColor: '#e3e3e3',
      height: 26,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      lineHeight: '30px',
      '&:hover': {
        // backgroundColor: "transparent"
      },
    },
  });
export default withStyles(styles)(SearchBar);
